module.exports = __webpack_public_path__ + "static/img/answer-question.717c3f1.png";


//////////////////
// WEBPACK FOOTER
// ./static/runtime/images/magic/answer-question.png
// module id = QTv+
// module chunks = 1